import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, forkJoin, map, Subject} from 'rxjs';
import {DepotMasterTab1} from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import {BackendListModel} from 'src/app/models/common/list.model';
import {LocationModel} from 'src/app/models/container_master_model/location';
import {DoContact} from 'src/app/models/do-contact';
import {ReleaseOrder, ReleaseOrderClass, SupplierDOModel} from 'src/app/models/release-order';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {DomainCodeApiService} from 'src/app/services/domain_code/domain-code-api.service';
import {LocationApiService} from 'src/app/services/domain_code/location-api.service';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {EmbassyService} from 'src/app/services/embassy.service';
import {FeedbackMasterApiService} from 'src/app/services/feedback-master-api.service';
import {ReleaseOrderService} from 'src/app/services/release-order.service';
import {WarningBoxComponent} from '../../dialog-box/warning-box/warning-box.component';
import {MatDialog} from '@angular/material/dialog';
import {DepotMasterApiService} from 'src/app/services/domain_code/depot-master-api.service';
import {TermsAndConditionsModel} from 'src/app/models/common/terms-and-conditions.model';
import {QuillEditorComponent} from 'ngx-quill';
import {AuthService} from 'src/app/services/auth.service';
import {
    SendEmailConfirmationComponent
} from '../../dialog-box/send-email-confirmation/send-email-confirmation.component';
import {ContactPersonsComponent} from '../../form-fields/contact-persons/contact-persons.component';
import {ValidateContainersComponent} from '../../../validate-containers/validate-containers.component';
import {MapDoComponent} from "../map-do/map-do.component";
import {RequestDetailsBookingChargesService} from "../../../services/request-details-booking-charges.service";

@Component({
    selector: 'logzy-release-order',
    templateUrl: './release-order.component.html',
    styleUrls: ['./release-order.component.scss']
})
export class ReleaseOrderComponent implements OnInit {
    errorObj: any = {};
    dd_depotLocation: any;
    storage_Charge: any;

    @Input()
    addRelease: boolean = false;
    // optionalfeedback: boolean=true;
    releaseOrder: any;
    externalDORevalidation: any;
    releaseOrderResponse: any;
    isShow: boolean = true;
    emptyList: boolean = false;
    currentDate = new Date();
    todayDate = new Date();
    isShown: boolean = false;
    disableSaveButton: boolean = false;
    isCancel: boolean = false;
    isHide: boolean = true;
    isCustomer: boolean;
    feedbackResponse: any;
    quoteList;
    termsConditionList: TermsAndConditionsModel[] = [];
    termsAndCondition: TermsAndConditionsModel;
    selectedTermsAndCondition: string = '';

    modules = {};
    @ViewChild('editor', {static: false}) editor: QuillEditorComponent;
    @ViewChild(ContactPersonsComponent) contactPersonsComponent: ContactPersonsComponent;
    @Input()
    isFeedbackSubmited: boolean = false;
    confirmationMessage: string;
    deleteExRevalidation: Object;
    dateDisabled: boolean = true;
    canvas: string = "Canvas";
    open1: string = "sidepanel";
    bindName = new BehaviorSubject(null);
    doType: any;
    @Output() selectDepotMaster = new EventEmitter<DepotMasterTab1>();
    doTypeList: any;
    isShownDOType: boolean = true;

    constructor(private releaseservice: ReleaseOrderService, private snackBar: MatSnackBar,
                public requestService: RequestApiService, private locationService: LocationApiService,
                private route: ActivatedRoute, private router: Router, private domainService: DomainCodeApiService,
                private feedbackService: FeedbackMasterApiService, public embassyService: EmbassyService,
                private dialog: MatDialog, private depotMasterApiService: DepotMasterApiService, public authService: AuthService, public requestDetailsBookingChargesService: RequestDetailsBookingChargesService,
    ) {
        this.modules = {
            toolbar: false
        }
    }

    depotSeleted: boolean = false;
    base_url = ApiRoutes.Location;
    requestUrl = ApiRoutes.LeadRequest;
    supplierUrl = ApiRoutes.Booking;
    companyUrl = ApiRoutes.Company;

    loading: boolean = true;
    @Output() editRO = new EventEmitter<any>();
    @Output() cancelRO = new EventEmitter<any>();
    @Output() revalidateRO = new EventEmitter<any>();
    @Output() revalidateCRO = new EventEmitter<any>();
    @Output() openDepotForm = new EventEmitter<any>();
    @Output() navigatePickUp = new EventEmitter<any>();
    @Output() containerListRO = new EventEmitter<any>();
    @Output() pickupReturn = new EventEmitter<any>();


    @Input()
    refreshTable = new Subject();
    @Input() RefreshReleaseOrder = new Subject();

    selectedCurrency = '';

    defaultRelease: any;
    DOOwnerdata: any;
    showCancelled: any
    releaseObject: ReleaseOrderClass;
    defaultContact: any
    contactObject: DoContact = {
        id: null,
        name: null,
        email: null,
        designation: null,
        contact_no: null,
        mobile_no: null,
        do: null,
        type: null,
        is_active: true
    }
    defaultDepot: DepotMasterTab1 = {
        id: null,
        name: null,
        location_type: '',
        depot_owner_type: null,
        local_name: null,
        address: null,
        agreement_valid_date: null,
        location_billing_type: null,
        location_email: null,
        location_contact_no: null,
        working_hrs_from: null,
        working_hrs_to: null,
        week_offs: null,
        is_edi_available: true,
        edi_code: null,
        remarks: null,
        country: null,
        state: null,
        depot_week_offs: '',
        ports: [],
        connectivities: [],
        free_storage_days_upto_teus: null,
        is_active: true
        // approachable_via:[]
    }
    selectedDepotObj = {...this.defaultDepot};

    // pickupLocationListUrl = `${this.locationService.base_url}?search=::search::&pickup_request_id=::request_id::`
    // pickupLocationListUrlTransforms = {
    //     request_id: ''
    // }

    pickupLocationListUrl1 = '';

    showDepotDetailsSection: boolean = false;
    addressRequired: boolean = false;
    hasPropertyIsInternational: boolean = false;
    isShownOptions: boolean = true;
    transactionType: string | any = '';
    requestType: string = '';
    bookingListUrl = '';
    supplierListUrl = '';
    supplierDOListUrl = '';
    requirementListUrl = ''
    dev_value: string = '';
    showAddress: boolean = false;
    selectedSupplierDO: SupplierDOModel = null;

    requirementList: [] = [];

    doOwnerId: string = '';
    isShownContainer: boolean = false;
    requirement:string;
    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        if (this.isCustomer && this.requestService.selectedRequest.transaction_type == 'use') {
            this.isShownOptions = false;
        }
        console.log("isCustomer", this.isCustomer);
        this.requirementList = [];
        this.getAllDOowner();
        this.pickupLocationListUrl1 = null;
        this.getAllData();
        this.getTermsAndConditionMasterList();
        // this.getQuotes(this.requestService.selectedRequest);

        // console.log(this.requirementList);
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getRequestDetails(params['id']);
                this.getFeedbackByReqId(params['id']);
                this.releaseObject.do_owner = null;
                this.getAllDOowner();
                this.pickupLocationListUrl1 = null;
                this.getAllData();
            }

            if ('type' in params) {
                this.transactionType = params['type'];
            } else {
                this.transactionType = this.requestService.selectedRequest.transaction_type;
            }

            if ('rtype' in params) {
                this.requestType = params['rtype'];
            } else {
                this.requestType = this.requestService.selectedRequest.request_type?.dev_name;
            }
        });

        this.depotMasterApiService.depotSubject.subscribe(data => {
            // console.log('New Depot received', data);
            this.releaseObject.depot = data;
            this.selectedDepot(this.releaseObject.depot);
        });
        this.depotMasterApiService.contactSubject.subscribe((data:any) => {
            console.log("data...contact",data)
            this.releaseObject.depot_contact_full_name = (data.first_name ?? '') + ' ' + (data.last_name ?? '');
            this.releaseObject.depot_contact_email = data.email ?? '';
            this.releaseObject.depot_contact_number = data.phone.as_e164;
        });
        this.doTypeList = [
            {
                id: 1,
                value: 'Open DO',
                desc: 'Create delivery order to be issued without specific container numbers, allowing flexible container allocation.'
            },
            {
                id: 2,
                value: 'Closed DO',
                desc: 'Create delivery order to be issued with pre-assigned container numbers for precise tracking and handling.'
            }
        ]
        // this.doType = this.doTypeList.find(type => type.value === 'Open DO');
        this.doType = this.doTypeList[0];


    }

    getRequestDetails(id) {
        this.requestService.getRequestDetailsById(id).subscribe({
            next: response => {
                this.requestService.selectedRequest = {...response};
                this.requirementList = this.requestService.selectedRequest.requirement;
                console.log('ngOnInit --------------------------> ', this.requestService.selectedRequest.requirement);
            }
        });
    }

    getAllData() {
        this.releaseObject = new ReleaseOrderClass();
        this.releaseObject.billed_from = this.currentDate;
        let valid_till = new Date(this.currentDate);
        valid_till.setDate(valid_till.getDate() + 14);
        this.releaseObject.valid_till = valid_till;
        // this.getQuotes(this.requestService.selectedRequest);
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                // this.pickupLocationListUrlTransforms = {
                //     request_id: params['id']
                // }
                this.getReleaseorderbyReqID(params['id']);
                // this.getDepotName(params['id']);
                // this.getQuotes(params['id']);
            }
        });
    }

    // getQuotes(request) {
    //     this.requestService.getlastQuote(request).subscribe({
    //         next: response => {
    //             this.quoteList = response.results;
    //             console.log("this.quoteList",this.quoteList);
    //         },
    //     });
    // }
    getQuotes(id) {
        return this.requestService.getlastQuote(id).subscribe(
            (response => {
                this.quoteList = response.results;
                this.releaseObject.storage_charge = this.quoteList[0]?.latest_quote?.storage_charge ?? '0';
                this.releaseObject.storage_charge_currency = this.quoteList[0]?.latest_quote?.storage_charge_currency ?? 'USD';
                console.log("Storae Charge From Quote", this.quoteList[0]?.latest_quote?.storage_charge)
            }));
    }

    changeDOowner(event) {
        this.isShownContainer = false;
        console.log('changeDOowner', event);
        if (event == null || event == undefined) {
            console.log("event", event)
        } else {
            console.log("else event", event);
            this.dev_value = event.dev_value;
            if (event?.id == this.DOOwnerdata[0]?.id) {
                this.isShown = false;
                this.depotAddress = null;
                this.releaseObject.depot = null;
                this.doOwnerId = event?.id;
                this.isShownDOType = true;
                this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${event?.id}&pickup_requirement_id=${this.releaseObject.requirement.id}`
            } else {
                this.isShown = true;
                this.depotAddress = null;
                this.releaseObject.depot = null;
                this.doOwnerId = event?.id;
                this.isShownDOType = false;
                // this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${event?.id}&pickup_requirement_id=${this.releaseObject.requirement}`
            }

            this.bookingListUrl = `${this.requestUrl}request_details/?request_type=${this.requestType}&transaction_type=${this.transactionType == 'use' ? 'supply' : 'use'}&search=::search::`
            this.supplierListUrl = `${this.companyUrl}company_short/?is_internal=0&search=::search::`
            this.releaseObject.depot = null;
            this.releaseObject.supplier = null;
            this.releaseObject.supply_do = null;
            this.releaseObject.supply_mappings = null;
            this.releaseObject.depot_contact_email = null;
            this.releaseObject.depot_contact_number = null;
            this.releaseObject.depot_contact_full_name = null;
            this.selectedSupplierDO = null;
        }
        this.showDepotDetailsSection = false;

    }

    postReleaseOrder(data) {
        data['address'] = this.depotAddress;
        console.log(this.dev_value);
        // if (data['depot_contact_number'] != null)
        //     data['depot_contact_number'] = data['depot_contact_number'].as_e164;
        if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'buy_sell' || this.requestType == 'empty_repo') && this.dev_value == 'supplier') {
            data['supply_mappings'] = [];
            data['supply_do'] = this.selectedSupplierDO ? this.selectedSupplierDO.id : null;
        } else if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'buy_sell' || this.requestType == 'empty_repo') && this.dev_value == 'arcon') {
            data['supply_do'] = null;
        }

        let contacts = [];
        if (this.transactionType == 'use') {
            this.contactPersonsComponent.contacts.map(contact => {
                contacts.push({
                    contact_full_name: contact.contact_name,
                    contact_number: contact.contact_number,
                    contact_email: contact.contact_email,
                    designation: contact.profile_role
                })
            });
        }
        data['contacts'] = contacts;
        console.log("data['contacts']", data['contacts']);

        this.disableSaveButton = true;
        let contact = {...this.contactObject};
        this.releaseservice.postReleaseOrder(data).subscribe({
            next: response => {
                // this.postContact(contact, response.id);
                this.snackBar.open("Release Order Created Successfully.", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.releaseOrderResponse = response;
                this.releaseObject = new ReleaseOrderClass();
                this.getAllDOowner();
                this.getAllData();
                this.contactObject = {...this.defaultContact};
                this.disableSaveButton = false;
                this.addRelease = false;
                this.showDepotDetailsSection = false;
                if (this.transactionType == 'use') {
                    this.contactPersonsComponent.resetContacts();
                }
                // get_back_here
                this.requestDetailsBookingChargesService.bookingDetailsUpdated$.next(true);
                // console.log('this is after postReleaseOrder bookingDetailUpdated' );

                // if (this.transactionType == 'supply') {
                //     this.openWarningForDO('Link DO/RO', 'Do you wish to create a New Request or Link DO/RO to a USE' +
                //         ' request', 'Skip', 'New Request', 'Map Request');
                // }
            },
            error: error => {
                this.disableSaveButton = false;
                if (error.error.quantity) {
                    // if (error.error.quantity[0].includes('0'))
                    if (this.releaseObject.quantity != null)
                        this.openWarning(error.error.quantity[0], '', 'I Understand');
                    else
                        this.openWarning('Release quantity cannot be null', '', 'I Understand');
                }
                return this.catchError(error);
            }
        })
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }

    openWarningForDO(label: string, description, label1: string, label2?: string, label3?: string) {
        const dialogRef = this.dialog.open(MapDoComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                title: label,
                parent: this,
                description: description,
                supplyDO: this.releaseOrderResponse.id
            }
        });
    }

    postContact(data, relOrderId) {
        data['email'] = this.releaseObject.depot_contact_email;
        // if (data?.contact_no?.first_name != null) {
        data['name'] = this.releaseObject.depot_contact_full_name;
        // }
        // data['name'] = data?.contact_no?.first_name ?? '' + ' ' ?? '' + data?.contact_no?.last_name ?? '';

        data['contact_no'] = this.releaseObject.depot_contact_number;
        data['do'] = relOrderId;
        // if (data?.contact_no?.phone?.as_international) {
        //     data['contact_no'] == data?.contact_no?.phone?.as_international;
        // }
        // else {
        //     data['contact_no'] == null;
        // }
        this.releaseservice.postDOContact(data).subscribe({
            next: response => {
                this.snackBar.open("Create Release Contact Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.getReleaseorderbyReqID(this.requestService.selectedRequest.id);
            },
        })
    }

    getAllDOowner() {
        return this.domainService.getByGroup('DOOwner').subscribe(
            (response => {
                if (this.transactionType == 'supply') {
                    this.DOOwnerdata = response.results[1];
                    this.isShown = true;
                    this.depotAddress = null;
                    this.releaseObject.depot = null;
                    // this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.DOOwnerdata.id}&pickup_request_id=${this.requestService.selectedRequest.id}`
                    this.releaseObject.do_owner = this.DOOwnerdata;
                } else {
                    this.DOOwnerdata = response.results;
                }
                console.log("DOOwnerdata", this.DOOwnerdata);

            }));
    }

    keysToTransform = ['do_owner', 'upload_document', 'depot'];

    saveOrder() {
        if (this.transactionType == 'use') {
            if (this.contactPersonsComponent.contacts.length == 0) {
                this.openWarning('Please add atleast 1 contact person ', '', 'I Understand');
                return;
            }
            // else {
            //     let contactFlag = false;
            //     this.contactPersonsComponent.contacts.map(contact => {
            //         if (contact.contact_name.trim() == '' || contact.contact_email.trim() == '' || contact.contact_number.trim() == '' || contact.profile_role.trim() == '') {
            //             contactFlag = true;
            //         }
            //     });

            //     if (contactFlag) {
            //         this.openWarning('User Contact Details cannot be empty', '', 'I Understand');
            //         return;
            //     }
            // }
            let contactFlag = this.contactPersonsComponent.contacts.some(contact =>
                contact.contact_full_name?.trim() === '' ||
                contact.contact_email?.trim() === '' ||
                contact.contact_number?.trim() === '' ||
                contact.designation?.trim() === ''
            );

            if (contactFlag) {
                this.openWarning('User Contact Details cannot be empty', '', 'I Understand');
                return;
            }
        }

        if (this.releaseObject.billed_from != null && this.releaseObject.valid_till != null) {
            const billed_from = new Date(this.releaseObject.billed_from);
            const utcDate = new Date(billed_from.toUTCString());
            utcDate.setHours(0, 0, 0, 0);
            this.releaseObject.billed_from = utcDate.toISOString();

            const valid_till = new Date(this.releaseObject.valid_till);
            const utcDate1 = new Date(valid_till.toUTCString());
            utcDate1.setHours(0, 0, 0, 0);
            this.releaseObject.valid_till = utcDate1.toISOString();

        }

        if (this.contactObject.contact_no != null) {
            if (this.contactObject.contact_no.hasOwnProperty('id')) {
                this.releaseObject.depot_contact_full_name = this.contactObject.contact_no.first_name + ' ' + this.contactObject.contact_no.last_name;
                this.releaseObject.depot_contact_email = this.contactObject.contact_no.email;
                this.releaseObject.depot_contact_number = this.contactObject.contact_no.phone.as_international;
            }
        }
        if (this.transactionType != 'supply') {
            this.releaseObject.terms_and_condition_fk = this.termsAndCondition.id;
            this.releaseObject.terms_and_condition_text = this.selectedTermsAndCondition;
        }
        this.releaseObject.requirement = this.requirement;
        this.postReleaseOrder(this.releaseObject.postReleaseOrder());
    }

    getReleaseorderbyReqID(id) {
        this.releaseservice.getReleaseOrderbyRequestId(id).subscribe({
            next: response => {
                this.releaseOrder = response;
                console.log("this.releaseOrder.do_list", this?.releaseOrder?.do_list)
                this.loading = false;
                console.log("the release order is", this.releaseOrder.do_list.length);
                if (this.releaseOrder.do_list.length) {
                    this.emptyList = false;
                    // this.releaseservice.isShowRejectBooking = false;
                    console.log("empty list is ", this.emptyList);
                } else {
                    this.emptyList = true;
                    // this.releaseservice.isShowRejectBooking = true;
                    console.log("empty list is", this.emptyList);

                }
            },
        })
    }

    getDepotName(id) {
        return this.releaseservice.getDepotLocationbyPickupreqID(this.requestService.selectedRequest.id).subscribe(
            (response => {
                this.dd_depotLocation = response;
            }));
    }

    getStorageCharge(DId, CId) {
        return this.releaseservice.getStorageChargebyDepotID(DId, this.requestService?.selectedRequest?.requirement[0]?.container_size_type?.size).subscribe(
            (response => {
                this.storage_Charge = response?.results;
                this.releaseObject.storage_charge = this.storage_Charge[0]?.charge_rate;
                this.releaseObject.storage_charge_currency = this.storage_Charge[0]?.charge_rate_currency;
                console.log("this.storage_Charge", this.storage_Charge[0]?.charge_rate);
                console.log("this.storage_Charge Currency", this.storage_Charge[0]?.charge_rate_currency);

            }));
    }

    EditOrder(item) {
        this.editRO.emit(item);
        // this.editRO.emit(contact);
        this.releaseservice.selectedOrder = {...item};
    }

    CancelOrder(item: ReleaseOrder) {
        this.cancelRO.emit(item);
        this.releaseservice.selectedOrder = {...item};
    }

    ReValidateOrder(item) {
        // if (item.supply_do != null && this.transactionType == 'use') {
        //     this.openWarning('Please revalidate the respective suppliers release order to proceed further', '', 'I Understand');
        // } else {
        this.revalidateRO.emit(item);
        // }
        this.releaseservice.selectedOrder = {...item};
    }

    ReValidateCustOrder(item) {
        this.revalidateCRO.emit(item);
        this.releaseservice.selectedOrder = {...item};
    }

    addDepotForm() {
        this.openDepotForm.emit();
        // this.releaseservice.selectedOrder = { ...item };
    }

    containerListReleaseOrder(item) {
        this.containerListRO.emit(item);
        // this.editRO.emit(contact);
        this.releaseservice.selectedOrder = {...item};
    }

    depotAddress: any;
    depotContacts = [];
    depotbind = new Subject();

    selectedDepot(depot) {
        console.log('selectedDepot', depot);
        if (this.releaseObject.do_owner?.id != null) {
            // this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.DOOwnerdata.id}&pickup_requirement_id=${this.releaseObject.requirement}`;
            // &depot_owner_type=${this.releaseObject.do_owner?.id}
        }

        this.depotSeleted = true;
        this.depotAddress = depot?.address;
        this.depotContacts = depot?.contacts;


        // this.getStorageCharge(depot?.id, this.requestService?.selectedRequest?.requirement[0]?.container_size_type?.size)
        // if (depot.name_display) {
        //     this.addDepotForm()
        // }
        if (depot != null) {
            if (depot.id != null) {
                this.closeEdit();
                console.log('this.depotContacts', this.depotContacts);
                this.showDepotDetailsSection = true;
                if (this.depotContacts.length == 0) {
                    this.showAddress = false;
                    this.releaseObject.depot_contact_full_name = null;
                    this.releaseObject.depot_contact_email = null;
                    this.releaseObject.depot_contact_number = null;

                } else {
                    // this.releaseObject.depot_contact_full_name = this.depotContacts[0].first_name + ' ' + this.depotContacts[0].last_name;
                    this.releaseObject.depot_contact_full_name =
                        this.depotContacts[0].first_name != null ? (this.depotContacts[0].last_name != null
                                ? `${this.depotContacts[0].first_name} ${this.depotContacts[0].last_name}`
                                : this.depotContacts[0].first_name)
                            : (this.depotContacts[0].last_name != null
                                ? this.depotContacts[0].last_name
                                : '');

                    this.releaseObject.depot_contact_email = this.depotContacts[0].email;
                    this.releaseObject.depot_contact_number = this.depotContacts[0].phone?.as_e164;
                    this.showAddress = true;
                }
            } else {
                let depotObj = {...this.defaultDepot};
                depotObj.name = depot.name_display
                this.showDepotDetailsSection = false;
                // this.addDepotForm();
                this.openDepotForm.emit(depot);
            }
            this.addressRequired = true;

        }
        this.hasPropertyIsInternational = false;
        if (depot == null) {
            this.releaseObject.depot_contact_full_name = null;
            this.releaseObject.depot_contact_email = null;
            this.releaseObject.depot_contact_number = null;
        }
        // this.contactObject.contact_no = null;
        // this.depotObj.requestor = event;
    }

    onRequirementChange(event) {
        console.log('onRequirementChange', event);
        if (event == null) {
            this.showDepotDetailsSection = false;
            this.pickupLocationListUrl1 = null;
        } else {
            this.showDepotDetailsSection = false;
            this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.DOOwnerdata.id}&pickup_requirement_id=${this.releaseObject.requirement.id}`
            this.requirement = event.requirement;
            if(this.releaseObject.requirement.storage_charge!=null){
                this.releaseObject.storage_charge = this.releaseObject.requirement.storage_charge;
                this.releaseObject.storage_charge_currency = this.releaseObject.requirement.storage_charge_currency;
            }
            else{
                this.getStoragechargebyReqId(this.requirement);
            }
        }
        this.releaseObject.depot = null;
    }

    onRequirementChangeUse(event) {
        if (event == null) {
            this.showDepotDetailsSection = false;
            this.pickupLocationListUrl1 = null;
            this.releaseObject.do_owner = null;
            this.releaseObject.depot = null;
        } else {
            this.showDepotDetailsSection = false;
            this.releaseObject.depot = null;
            this.requirement = event.requirement;
            this.pickupLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.doOwnerId}&pickup_requirement_id=${this.releaseObject.requirement.id}`
            if(this.releaseObject.requirement.storage_charge!=null){
                this.releaseObject.storage_charge = this.releaseObject.requirement.storage_charge;
                this.releaseObject.storage_charge_currency = this.releaseObject.requirement.storage_charge_currency;
            }
            else{
                this.getStoragechargebyReqId(this.requirement);
            }

        }
    }

    selectedAddress(address: []) {
        console.log('address', address)
        if (address != null) {
            if (address.hasOwnProperty('id')) {
                console.log('Has Property Id');
                this.showAddress = false;
                this.hasPropertyIsInternational = false;
            } else {
                console.log('Has Property Is International');
                this.showAddress = true;
                this.hasPropertyIsInternational = true;
            }
        } else {
            this.showAddress = false;
        }
    }

    // this.depotObj.requestor = event;
    selectcontact: any;

    selectedContact() {
        this.selectcontact = this.contactObject.contact_no;
        console.log(" this.selectcontact", this.selectcontact);
    }

    denyRequest(item) {
        this.releaseservice.deleteExternalRevalidationbyid(item.external_do_revalidation_request[0].id).subscribe({
            next: response => {
                this.deleteExRevalidation = response;
                this.snackBar.open("Deny External DO Revalidation Request Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.isHide = false;
                this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);

            },
        })
    }

    navigatePickup(item) {
        this.releaseservice.selectedOrder = {...item};
        this.router.navigateByUrl['']
        this.navigatePickUp.emit('pickup_return');
    }

    setDisabled(date) {
        if (date != null) {
            this.releaseObject.valid_till = null;
            this.dateDisabled = false;
        }
        if (date == null) {
            this.releaseObject.valid_till = null;
            this.dateDisabled = true;
        }
    }

    dateChange(billed_from) {
        let valid_till = new Date(billed_from);
        valid_till.setDate(valid_till.getDate() + 14);
        this.releaseObject.valid_till = valid_till
    }

    feedbackSubmit(a) {
        this.isFeedbackSubmited = a;
        // this.confirmationSrc = "assets/images/backgrounds/business.svg";
        this.confirmationMessage = "Thanks for sharing your valuable feedback.";

    }

    checkFeedback(a) {
        if (a) {
            this.isFeedbackSubmited = false;
            console.log('this.feedbackSubmited', this.isFeedbackSubmited)
        } else {
            console.log('this is not what i thought')
        }
    }

    getFeedbackByReqId(id) {
        this.feedbackService.getFeedbackbyReqID(id).subscribe({
            next: response => {
                this.checkFeedbackresponse(response);
                // setTimeout(() => {
                //   }, 50);
                // this.feedbackResponse = response.results;
            },
        })

    }

    checkFeedbackresponse(response) {
        if (response.results.length > 0) {
            this.isFeedbackSubmited = true;
        } else {
            this.isFeedbackSubmited = false;

        }
    }

    openEdit(data) {
        this.open1 = " sidepanel slidepanelOpen ";
        this.canvas = "Canvas setCanvas";
        setTimeout(() => {
            this.bindName.next(data);
        }, 500);
    }

    closeEdit() {
        this.open1 = " sidepanel ";
        this.canvas = "Canvas ";
        this.bindName.next(null);
    }

    bindRequestor(event) {
        if (event != null) {
            // this.requestObj.requestor = event;
            this.closeEdit();
        }
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        }
    }

    filterSupplierDO(event) {
        console.log('filterSupplierDO', event);
        if (event != null) {
            // this.supplierDOListUrl = `${this.supplierUrl}do_details_autocomplete/?search=::search::&request_id=${event.id}&for_use_requirement_id=${this.requestService.selectedRequest?.requirement[0].id}`;
            this.releaseObject.depot = null;
            this.releaseObject.supply_mappings = null;
            this.releaseObject.depot_contact_email = null;
            this.releaseObject.depot_contact_number = null;
            this.releaseObject.depot_contact_number = null;
            this.showDepotDetailsSection = false;
            this.releaseObject.supply_do = null;
            this.selectedSupplierDO = null;
            console.log('this.releaseObject.requirement', this.releaseObject.requirement);
            this.supplierDOListUrl = `${this.supplierUrl}do_details_autocomplete/?search=::search::&requestor_company_id=${event.id}&for_use_requirement_id=${this.requirement}`;
        }
    }

    loadSupplierAddress(event) {
        if (event != null) {
            this.selectedSupplierDO = event;
            // console.log(this.selectedSupplierDO);
            this.releaseObject.depot_contact_full_name = event.depot_contact_full_name;
            this.releaseObject.depot_contact_email = event.depot_contact_email;
            this.releaseObject.depot_contact_number = event.depot_contact_number;
            this.showDepotDetailsSection = true;
            this.releaseObject.depot = event.depot;
            this.releaseObject.storage_charge = event.storage_charge;
            this.releaseObject.storage_charge_currency = event.storage_charge_currency;
            this.releaseObject.billed_from = event.billed_from;
            this.releaseObject.valid_till = event.valid_till;
            this.releaseObject.do_reference_no = event.do_reference_no;
            this.releaseObject.handling_remarks = event.handling_remarks;

        }
    }

    addNewDepot(depot) {
        console.log('New Added Depot', depot);
    }

    loadDO(item) {
        // console.log(item.supply_do.request.id, item.supply_do.request.transaction_type, item.supply_do.request.request_type.dev_name);
        window.open(`/requests/request-processing/request-details?id=${item.supply_do.request.id}&type=${item.supply_do.request.transaction_type}&rtype=${item.supply_do.request.request_type.dev_name}&mode=ro`, '_blank');
    }

    showSelectedTermsAndCondition() {
        if (this.termsConditionList.length != 0) {
            this.termsConditionList.map(item => {
                if (item.id == this.termsAndCondition) {
                    this.termsAndCondition = {
                        id: item.id,
                        name: item.name
                    };
                    this.selectedTermsAndCondition = item.terms_condition;
                }
            })
        }
    }

    getTermsAndConditionMasterList() {
        this.requestService.getTermsAndConditionsListDO(this.requestService.selectedRequest, 'delivery order').subscribe({
            next: response => {
                this.termsConditionList = response.results;
                if (this.termsConditionList.length != 0) {
                    this.termsAndCondition = {
                        id: this.termsConditionList[0].id,
                        name: this.termsConditionList[0].name
                    };
                    this.selectedTermsAndCondition = this.termsConditionList[0].terms_condition;
                }
                return response;
            },
            error: error => {
                console.log(error)
                return error;
            }
        })
    }

    getStoragechargebyReqId(reqId) {
        this.requestService.getStorageChargebyRequirementId(reqId).subscribe({
            next: response => {
                this.requirementListUrl = response;
                this.releaseObject.storage_charge = response.storage_charge;
                if (this.releaseObject.storage_charge != null) {
                    this.releaseObject.storage_charge_currency = response.storage_charge_currency;
                } else {
                    this.releaseObject.storage_charge_currency = 'USD';
                }
                console.log("this.requirementListUrl", this.requirementListUrl)
            }
        })
    }

    openSendConfirmationDialog(item, snackBarMessage, mailType): void {
        console.log(item);
        let htmlContent: string = '';
        this.requestService.getEmailContent(item.id, mailType).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [this.requestService.selectedRequest.requestor?.email],
                    userListKey: '',
                    contentURL: ApiRoutes.QuoteConfirmEmailUrl,
                    contentKeys: {
                        to_emails: '',
                        subject: 'Release order generated for ' + item?.do_reference_no,
                        content: htmlContent
                    },
                    mailType: mailType,
                    snackBarMessage: snackBarMessage

                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        console.log('User clicked Yes');
                        this.disableSaveButton = false;
                    } else {
                        this.disableSaveButton = false;
                    }
                    // window.location.reload();
                });

                dialogRef.componentInstance.emailSend.subscribe(() => {
                    this.snackBar.open("Release order shared on email", 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                    });
                });
            },
            (error) => {
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    doTypeChange(event) {
        if (event.value == 'Closed DO') {
            this.isShownContainer = true;
        } else {
            this.isShownContainer = false;
            this.releaseObject.container_numbers = null;
        }

    }

    releaseOrderData: any;

    postValidateContainers(data) {
        this.loading = true;
        data['address'] = this.depotAddress;
        data['requirement'] = this.requirement;
        console.log(this.dev_value);
        if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'buy_sell' || this.requestType == 'empty_repo') && this.dev_value == 'supplier') {
            data['supply_mappings'] = [];
            data['supply_do'] = this.selectedSupplierDO ? this.selectedSupplierDO.id : null;
        } else if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'buy_sell' || this.requestType == 'empty_repo') && this.dev_value == 'arcon') {
            data['supply_do'] = null;
        }

        let contacts = [];
        if (this.transactionType == 'use') {
            this.contactPersonsComponent.contacts.map(contact => {
                contacts.push({
                    contact_full_name: contact.contact_name,
                    contact_number: contact.contact_number,
                    contact_email: contact.contact_email,
                    designation: contact.profile_role
                })
            });
        }
        data['contacts'] = contacts;
        console.log("data['contacts']", data['contacts']);

        this.disableSaveButton = true;
        let contact = {...this.contactObject};
        this.releaseOrderData = data;
        // const splitArray = data['container_numbers'].split(/[,\n\s]+/);
        if (data['container_numbers']) {
            const splitArray = data['container_numbers']
                ?.split(/[,\n\s]+/)
                .map(item => item.trim())
                .filter(item => item !== '');
            const uniqueArray = Array.from(new Set(splitArray));
            data['container_numbers'] = uniqueArray.join(", ");
            data['quantity'] = uniqueArray.length;
        }
        this.releaseservice.postValidateContainer(data).subscribe({
            next: response => {
                // this.snackBar.open("Release Order Created Successfully.", 'Close', {
                //     verticalPosition: 'top',
                //     duration: 2000,
                // });
                this.releaseOrderResponse = response;
                if (response[0]?.container_number != null) {
                    this.openDialog();
                } else {
                    this.openWarning('No Containers are added', '', 'I Understand');
                }
                // this.getAllDOowner();
                // this.getAllData();
                // this.contactObject = { ...this.defaultContact };
                this.disableSaveButton = false;
                this.addRelease = true;
                this.showDepotDetailsSection = false;
                // if (this.transactionType == 'use') {
                //     this.contactPersonsComponent.resetContacts();
                // }
                this.loading = false;
                //     get_ba
            },
            error: error => {
                this.loading = false;
                this.disableSaveButton = false;
                if (error.error.quantity) {
                    // if (this.releaseObject.quantity != null)
                    this.openWarning(error.error.quantity[0], '', 'I Understand');
                    // else
                    //     this.openWarning('Release quantity cannot be null', '', 'I Understand');
                }
                return this.catchError(error);
            }
        })
    }


    validateContainers() {
        console.log(this.doType)
        if (this.transactionType == 'use') {
            if (this.contactPersonsComponent.contacts.length == 0) {
                this.openWarning('Please add atleast 1 contact person ', '', 'I Understand');
                return;
            }
            // else {
            //     let contactFlag = false;
            //     this.contactPersonsComponent.contacts.map(contact => {
            //         if (contact.contact_name.trim() == '' || contact.contact_email.trim() == '' || contact.contact_number.trim() == '' || contact.profile_role.trim() == '') {
            //             contactFlag = true;
            //         }
            //     });

            //     if (contactFlag) {
            //         this.openWarning('User Contact Details cannot be empty', '', 'I Understand');
            //         return;
            //     }
            // }
            let contactFlag = this.contactPersonsComponent.contacts.some(contact =>
                contact.contact_full_name?.trim() === '' ||
                contact.contact_email?.trim() === '' ||
                contact.contact_number?.trim() === '' ||
                contact.designation?.trim() === ''
            );

            if (contactFlag) {
                this.openWarning('User Contact Details cannot be empty', '', 'I Understand');
                return;
            }
        }

        if (this.releaseObject.billed_from != null && this.releaseObject.valid_till != null) {
            const billed_from = new Date(this.releaseObject.billed_from);
            const utcDate = new Date(billed_from.toUTCString());
            utcDate.setHours(0, 0, 0, 0);
            this.releaseObject.billed_from = utcDate.toISOString();

            const valid_till = new Date(this.releaseObject.valid_till);
            const utcDate1 = new Date(valid_till.toUTCString());
            utcDate1.setHours(0, 0, 0, 0);
            this.releaseObject.valid_till = utcDate1.toISOString();

        }

        if (this.contactObject.contact_no != null) {
            if (this.contactObject.contact_no.hasOwnProperty('id')) {
                this.releaseObject.depot_contact_full_name = this.contactObject.contact_no.first_name + ' ' + this.contactObject.contact_no.last_name;
                this.releaseObject.depot_contact_email = this.contactObject.contact_no.email;
                this.releaseObject.depot_contact_number = this.contactObject.contact_no.phone.as_international;
            }
        }
        if (this.transactionType != 'supply') {
            this.releaseObject.terms_and_condition_fk = this.termsAndCondition.id;
            this.releaseObject.terms_and_condition_text = this.selectedTermsAndCondition;
        }

        this.postValidateContainers(this.releaseObject.postReleaseOrder());
    }

    openDialog(): void {
        const dialogData = {
            data: this.releaseOrderResponse,
            releaseOrderData: this.releaseOrderData
        };
        const dialogRef = this.dialog.open(ValidateContainersComponent, {
            width: '100%', // Set the width of the dialog
            disableClose: true,
            data: dialogData
        });

        // Optionally, you can subscribe to dialog close events
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
            } else {
            }
        });

        dialogRef.componentInstance.releaseSaved.subscribe(() => {
            this.snackBar.open("Release Order Created Successfully!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
            this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);
            this.getAllData();
            this.contactObject = {...this.defaultContact};
            if (this.transactionType == 'use') {
                this.contactPersonsComponent.resetContacts();
            }

        });
    }

    containersList: any;

    getAllContainersbyDoId(id) {
        this.releaseservice.getAllContainersbyDoId(id).subscribe({
            next: response => {
                this.containersList = response.results;
            },
        })
    }
}
